<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">
        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="employee-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('employee-role')"
                      to="employee-role">
              <i class="lnr-users btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Funções
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('employee-exam')"
                      to="employee-exam">
              <i class="lnr-heart-pulse btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Exames
            </t-button>
          </div>

        </div>
      </div>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'EmployeeSettings',
  data() {
    return {}
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
